import React from 'react';
import { Avatar as MuiAvatar, AvatarProps as MuiAvatarProps } from '@material-ui/core';
import styled from 'styled-components';

type AvatarProps = MuiAvatarProps & Pick<CircleIconProps, 'color' | 'isSmall'>;

interface CircleIconProps extends MuiAvatarProps {
    isSmall?: boolean;
    iconComponent: JSX.Element;
    color: 'primary' | 'success' | 'error';
}

const Avatar = styled(
    ({ color, isSmall, ...props }: AvatarProps) => <MuiAvatar {...props} />
)`
    ${props => props.color &&`
        && {
            border: 1px solid ${props.theme.palette[props.color].main};
            color: ${props.theme.palette[props.color].main};
            background-color: transparent;
        }
    `}
    ${props => props.isSmall &&`
        && {
            width: 20px;
            height: 20px;
            font-size: 12px;
        }
    `}
    && {
        position: unset;
    }
`;


const CircleIcon = ({ color, iconComponent, isSmall }: CircleIconProps) => (
    <Avatar color={color} isSmall={isSmall}>
        {iconComponent}
    </Avatar>
);

export default CircleIcon;
